import { render, staticRenderFns } from "./RsInformation.vue?vue&type=template&id=7a4cc56e&scoped=true&"
import script from "./RsInformation.vue?vue&type=script&lang=js&"
export * from "./RsInformation.vue?vue&type=script&lang=js&"
import style0 from "./RsInformation.vue?vue&type=style&index=0&id=7a4cc56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4cc56e",
  null
  
)

export default component.exports